import React, { useContext } from 'react';

import { FeatureContainer } from '../../components';
import * as ShippingConfig from './ShippingConfig';
import * as PreferredCarrier from './PreferredCarrier';
import Form from './Form';
import { AuthContext } from 'context/AuthContext';

const TITLE = {
  ALL: 'Who should pay for shipping returns and exchanges?',
  ONLY_RETURN: 'Who should pay for shipping returns?'
};

export default function Shipping() {
  const { isExchangeAllowed } = useContext(AuthContext);

  const title = isExchangeAllowed ? TITLE.ALL : TITLE.ONLY_RETURN;

  return (
    <FeatureContainer
      title={title}
      subtitle="Choose whether return shipping costs are covered by you or paid by your customers."
    >
      <ShippingConfig.Provider>
        <PreferredCarrier.Provider>
          <Form />
        </PreferredCarrier.Provider>
      </ShippingConfig.Provider>
    </FeatureContainer>
  );
}
